module.exports = __webpack_public_path__ + "static/media/jasper-24.101937ed.jpg";